import {useEffect} from 'react';

import {
    useParams
} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useDeploymentAccountGroup} from '../hooks/useDeploymentAccountGroup.ts';
import {useDeploymentAccountGroupsSelection} from '../hooks/useDeploymentAccountGroupsSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools';


export const EditPage = () => {

    const {id: groupId} = useParams();

    if (typeof groupId === 'undefined') {
        throw new Error('groupId is required parameter');
    }

    const {
        record,
    } = useDeploymentAccountGroup(groupId);

    const {handleClearSelection} = useDeploymentAccountGroupsSelection();

    const {
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only effect: deliberately runs once, adding deps would re-fire it
    }, []);

    if (!record) {
        return <PlatformLoader message='Loading deployment account group...Please wait'/>;
    }

    return (
        <FormPageLayout
            title={record.name ? record.name : record.id}
            pageNavigation={<EditPageNavigation component={record}/>}
            tools={tools}
        >

            <Grid>
                <Grid.Col span={{
                    base: 12,
                    lg: 6
                }}>
                    <Profile record={record}/>
                </Grid.Col>
            </Grid>

        </FormPageLayout>
    );
};
